import "../style/PopularServicesStyles.css"
import ServiceOne from "../assets/QueenNail/IMG_4220.png"
import ServiceTwo from "../assets/QueenNail/IMG_4237.jpg"
import ServiceThree from "../assets/QueenNail/download.png"
import ServiceFour from "../assets/QueenNail/IMG_4185.jpg"
import PopularServicesData from "./PopularServicesData"

/*TO ACCESS THE TEMPLATE OF POPULARSERVICES, GO TO POPULARSERVICESDATA.JS , THIS IS DATA PASSING*/
const PopularServices=()=>{
    return(
       <div className="popularServices">
        <h1>POPULAR SERVICES</h1>
        {/*<p>The most popular service at our shop</p>*/}

        <PopularServicesData
        className="first-service"
        heading="Design & Polish"
        text=""
        img1={ServiceOne}
        img2={ServiceTwo}
        />

        <PopularServicesData
        className="second-service"
        heading="Full Set"
        text=""
        img1={ServiceThree}
        img2={ServiceFour}
        />
        </div>
    )
}

export default PopularServices